export default "__VITE_ASSET__BsoeV$j6__"